import type { SportArtworkPixelSize } from './sport-artwork-types';

/** Smallest packaged resource that covers the display size at the requested density. */
export function sportArtworkPixelSize(size: number, density = 2): SportArtworkPixelSize {
  const pixels = size * density;
  if (pixels <= 64) return 64;
  if (pixels <= 128) return 128;
  if (pixels <= 256) return 256;
  return 512;
}
